var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseServer = function SvgChooseServer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8A5F4",
    fillRule: "evenodd",
    d: "M.2 1.6A1.6 1.6 0 0 1 1.8 0h22.4a1.6 1.6 0 0 1 1.6 1.6v3.2a1.6 1.6 0 0 1-1.6 1.6H1.8A1.6 1.6 0 0 1 .2 4.8zm23.2 1.6a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M1.8 8.8a1.6 1.6 0 0 0-1.6 1.6v3.2a1.6 1.6 0 0 0 1.6 1.6h22.4a1.6 1.6 0 0 0 1.6-1.6v-3.2a1.6 1.6 0 0 0-1.6-1.6zm20 4.8a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2M1.8 17.6a1.6 1.6 0 0 0-1.6 1.6v3.2A1.6 1.6 0 0 0 1.8 24h22.4a1.6 1.6 0 0 0 1.6-1.6v-3.2a1.6 1.6 0 0 0-1.6-1.6zm20 4.8a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2",
    clipRule: "evenodd"
  })));
};
export default SvgChooseServer;